// Date & time utilities — extracted from legacy-utils.ts

import moment from 'moment-timezone';
import momentDurationFormatSetup from 'moment-duration-format';
momentDurationFormatSetup(moment as any);

import { DATETIME_FORMAT_DISPLAY_LOCAL_MOMENT } from '@/utils/window-globals';

export function timeSinceFormatted(date: any): string {
  return (moment.duration(moment().utc().diff(date)) as any).format("Y[y] M[mo] D[d] h[h] m[m]");
}

export function durationFormatted(millisecondsDuration: number): string {
  return (moment.duration(millisecondsDuration) as any).format("Y[y] M[mo] D[d] h[h] m[m]");
}

export function timeSince(date: any): any {
  return moment.duration(moment().utc().diff(date));
}

export function isoDatetimeToFormattedDatetime(isoDate: any, datetimeLocalFormat: string): string {
  if ((isoDate === null) || (isoDate === undefined) || (isoDate === "")) {
    return isoDate;
  }
  return moment(isoDate).format(datetimeLocalFormat);
}

export function formattedDatetimeToISODateTime(formattedDatetime: string, datetimeISOFormat: string): string {
  if ((formattedDatetime === null) || (formattedDatetime === undefined) || (formattedDatetime === "")) {
    return formattedDatetime;
  }
  return moment(formattedDatetime, DATETIME_FORMAT_DISPLAY_LOCAL_MOMENT).utc().format(datetimeISOFormat);
}

export function currentISODateTime(datetimeISOFormat: string): string {
  return moment().utc().format(datetimeISOFormat);
}

export function getCurrentTimeUTC(): Date {
  return moment.utc().toDate();
}

export function getNullableDateClone(date: Date): Date | null {
  return ((date === null || date === undefined) ? (null) : (new Date(date)));
}

export function nullableMomentToDate(m: any): Date | null {
  return ((m === null || m === undefined) ? (null) : (m.toDate()));
}

export function isDateObject(object: any): boolean {
  return (Object.prototype.toString.call(object) === "[object Date]");
}

export function replaceISODateTimeValuesWithFormattedDateTimeAndTimeZoneAbbrValues(obj: Object, format: string): void {
  const timezone = moment().tz(moment.tz.guess()).format('z');
  for (var key in obj) {
    if (obj.hasOwnProperty(key) &&
      (typeof (obj as any)[key] === "string") &&
      (obj as any)[key].match(/\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/)) {
      (obj as any)[key] = moment((obj as any)[key]).format(format) + " " + timezone;
    }
  }
}
